export enum StakeholderRole {
  ACCOUNT_REQUESTER = 'ACCOUNT_REQUESTER',
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
  PRIMARY_BENEFICIAL_OWNER = 'PRIMARY_BENEFICIAL_OWNER',
  SECONDARY_BENEFICIAL_OWNER = 'SECONDARY_BENEFICIAL_OWNER',
}

export type Base64File = {
  base64content: string
  mimetype: string
  filename: string
}

export type StakeholderAddress = {
  addressLine1: string
  addressLine2?: string
  postalCode: string
  city: string
  stateOrProvince?: string
  country: string
}

export type Stakeholder = {
  id: string | null
  firstName: string
  kanaFirstName?: string
  latinFirstName?: string
  lastName: string
  kanaLastName?: string
  latinLastName?: string
  dateOfBirth: string
  countryOfBirth: string
  countryOfCitizenship: string
  countryOfResidency: string
  phoneNumber: string
  address: StakeholderAddress
  identityDocument: {
    identificationType?: string
    countryOfIssue: string
    front: Base64File
    back: Base64File | null
  }
  roles: StakeholderRole[]
}

export type KybStepCode =
  | 'BUSINESS_DETAILS'
  | 'ACCOUNT_REQUESTER_DETAILS'
  | 'LEGAL_REPRESENTATIVE_DETAILS'
  | 'PRIMARY_BENEFICIAL_OWNER_DETAILS'
  | 'LETTER_OF_AUTHORIZATION'
  | 'REVIEW'

export type KybStepStatus = 'TODO' | 'DONE' | 'ERROR'

export type KybStep = {
  value: KybStepCode
  label: string
  status: KybStepStatus
}

export type BusinessDetails = {
  legalName: string
  tradeName: string
  kanaLegalCompanyName?: string
  latinLegalCompanyName?: string
  countryOfRegistration: string
  registrationType: string
  registrationNumber: string
  incorporationDate: string
  email: string
  secondhandDealerNumber?: string
  secondhandDealerNumberIssuingPrefecture?: string
  proofOfSecondHandDealerLicence?: Base64File[]
  headquartersAddress: StakeholderAddress
  branchesAddresses: StakeholderAddress[]
  articleOfIncorporation: Base64File[]
  w9?: Base64File[]
  registeredBusinessAddress: StakeholderAddress
  investedCapital: {
    currency: string
    amount: number
  }
}

export type KybResponse = {
  steps: KybStep[]
  data: {
    business: BusinessDetails
    stakeholders: Stakeholder[]
    letterOfAuthorization: Base64File | null
  }
  errors: {
    entityId: string | null
    field: string
    message: string
  }[]
}

export type KybData = KybResponse['data']

export type LegalRepresentativeBody = {
  legalRepresentative: Stakeholder & {
    sameAsAccountRequester: boolean
  }
}

export type PrimaryBeneficialOwnerBody = {
  primary: Stakeholder & {
    sameAsAccountRequester: boolean
    sameAsLegalRepresentative: boolean
  }
  secondary: Stakeholder[]
}
